export default "__VITE_ASSET__C_whTZkp__"